<template>
  <div>
    <Appbar />
    <transition name="fade" mode="out-in">
      <router-view class="header-space-tcdc" style="min-height: 284px;"></router-view>
    </transition>
    <Footer />
  </div>
</template>
<script>
import Appbar from "../components/headers/Appbar";
import Footer from "../components/footers/Footer";

export default {
  components: {
    Appbar,
    Footer
  },
  created() {
    if (this.$route.path === "/") {
      this.$router.push("/landing");
    }
  }
};
</script>

<style>
.header-space-tcdc {
  padding-top: 7vh;
}
</style>
